// ActivityTabs.jsx
import React, { useState } from "react";
import { MdOutlineArrowDropDown } from "react-icons/md";
import moment from "moment";

export const ActivitiesStatus = ({ userDetails, activityStatus, statusData, handleApprovalChange, approvalFormData }) => {

  const activityList = [
    {
      sno: 1,
      title: "Introduction & Orientation to Platform",
      imgSrc: "insight/Manager-Assistance.svg",
      path: "/insight/meeting/introduction",
      type: "Meeting"
    },
    {
      sno: 2,
      title: "Case Study Reading & Preparation",
      imgSrc: "insight/Case-Study.svg",
      path: "/insight/casestudy",
      type: "Ready Only"
    },
    // {
    //   sno: 3,
    //   title: "Inbox Activity",
    //   imgSrc: "insight/Inbox-Activity.svg",
    //   path: "/insight/mailbox",
    //   type: "Response"
    // },
    // {
    //   sno: 4,
    //   title: "Behavioral Event Interview (BEI)",
    //   imgSrc: "insight/Behavioral-Event.svg",
    //   path: "/insight/meeting/interview",
    //   type: "Meeting"
    // },
    {
      sno: 5,
      title: "Stakeholder Roleplay Preparation",
      imgSrc: "insight/Subordinate-Role.svg",
      path: "/insight/roleplay",
      type: "Ready Only"
    },
    {
      sno: 6,
      title: "MS Teams Meeting Links (BEI, Case Study & Roleplay)",
      imgSrc: "insight/Play-Meeting.svg",
      path: "/insight/meeting/roleplay",
      type: "Meeting"
    },
    // {
    //   sno: 7,
    //   title: "Situational Judgement Test",
    //   imgSrc: "insight/Situational-Judgement.svg",
    //   path: "/insight/survey",
    //   type: "Response"
    // },
    // {
    //   sno: 8,
    //   title: "Case Study PPT Upload",
    //   imgSrc: "insight/Case-Study-PPT.svg",
    //   path: "/insight/upload",
    //   type: "Response"
    // },
  ];

  function getStatus(sno, activityStatus) {
    let status = "Pending";
    // replies
    if (sno === 3) {
      let flags = 0;

      if (Array.isArray(activityStatus?.replies) && activityStatus.replies.length > 0) {

        activityStatus.replies.forEach((inner = {}) => {
          if ((inner?.count || 0) > 0) {
            flags++;
          }
        });

        if (flags === activityStatus.replies.length) {
          status = "Completed";
        }

      }
    }
    // survey
    else if (sno === 7) {
      if (activityStatus?.survey?.isComplete === true) {
        status = "Completed";
      }
    }
    // uploads
    else if (sno === 8) {
      if ((activityStatus?.uploads?.count || 0) > 0) {
        status = "Completed";
      }
    }
    return status;
  }

  const activities = activityList
    .filter((ele) => (ele.type === "Response" || ele.type === "Meeting"))
    .map((ele) => ({
      sno: ele.sno,
      title: ele.title,
      imgSrc: ele.imgSrc,
      type: ele.type,
      assigned:
        statusData?.createdAt
          ? moment(statusData.createdAt).format("DD MMM, YYYY | hh:mm A")
          : "-",
      status: getStatus(ele.sno, activityStatus),
    }));

  let responses = activities.filter((ele) => (ele.type === "Response"))
  let statusPerc = responses?.length
    ? Math.round(
      ((responses?.filter((ele) => ele?.status === "Completed")?.length || 0) * 100) /
      responses.length
    )
    : 0;


  console.log("approvalFormData--->", approvalFormData)

  let objApprove = {}
  if (statusData && statusData.statusApprovals && statusData.statusApprovals.length > 0) {

    activities.forEach((ele) => {
      let getIndexV2 = statusData.statusApprovals.findIndex(prev => prev.activity === ele.sno.toString());
      if (getIndexV2 !== -1) {
        objApprove[ele.sno.toString()] = statusData.statusApprovals[getIndexV2]["status"];
      }
    })

    // approvalFormData?.[item?.sno] || ""
  }


  function checkApprove(ele, statusData) {
    let status = "Pending";
    if (statusData && statusData.statusApprovals && statusData.statusApprovals.length > 0) {
      let getIndexV2 = statusData.statusApprovals.findIndex(prev => prev.activity === ele.sno.toString());
      if (getIndexV2 !== -1) {
        status = statusData.statusApprovals[getIndexV2]["status"];
      }
    }
    return status
  }


  let approvePerc = activities?.length
    ? Math.round(
      (
        (activities?.filter(
          (ele) => checkApprove?.(ele, statusData) === "Approved"
        )?.length || 0) *
        100
      ) / (activities?.length || 1)
    )
    : 0;

  const getStatusLabel = (objApprove, item) => {
    return (objApprove[item.sno.toString()] || "Pending")
  }

  return (
    <div className="p-4 md:p-6 bg-white h-screen ">

      {/* Header */}
      <div className="bg-white rounded-md border border-gray-300 p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-indigo-600 flex items-center justify-center text-white text-xl font-bold">{userDetails.initial}</div>
          <div>
            <h2 className="font-semibold text-lg">{userDetails.name}</h2>
            <p className="text-gray-500 text-sm">{userDetails.email}</p>
          </div>
        </div>
        <div className="w-full md:w-1/2">

          <div className="space-y-5">

            {/* Activities Progress */}
            <div className=" p-4 shadow-sm space-y-4">

              {/* Activities Progress */}
              <div>
                <div className="flex items-center gap-3">

                  <h4 className="text-sm font-semibold text-gray-700 whitespace-nowrap min-w-[140px]">
                    Activities Progress
                  </h4>

                  <div className="flex-1 relative h-8 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-8 rounded-full bg-gradient-to-r from-[#000099] to-[#A3B3FF] transition-all duration-500 flex items-center justify-end pr-3"
                      style={{ width: `${statusPerc}%` }}
                    >
                      <span className="text-xs font-bold text-white">
                        {statusPerc}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Activities Approval */}
              <div>
                <div className="flex items-center gap-3">

                  <h4 className="text-sm font-semibold text-gray-700 whitespace-nowrap min-w-[140px]">
                    Activities Approval
                  </h4>

                  <div className="flex-1 relative h-8 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-8 rounded-full bg-gradient-to-r from-[#008060] to-[#00cc99] transition-all duration-500 flex items-center justify-end pr-3"
                      style={{ width: `${approvePerc}%` }}
                    >
                      <span className="text-xs font-bold text-white">
                        {approvePerc}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>



          </div>


        </div>
      </div>

      {/* Table */}
      <div className="md:pb-0 pb-16 mt-6">
        <h3 className="mb-3 font-semibold text-gray-900">Activity Status</h3>
        <div className="bg-white rounded-md border border-gray-300">
          {/* <div className="overflow-auto max-h-[600px]"> */}
          <div className="overflow-auto">
            <table className="min-w-[900px] w-full text-base text-left">
              {/* ✅ Sticky Header */}
              <thead className="bg-blue-100 text-gray-900 sticky top-0 z-10">
                <tr className="whitespace-nowrap">
                  <th className="p-3">Activity Name</th>
                  <th className="p-3">Assigned Date</th>
                  {/* <th className="p-3">Action</th> */}
                  <th className="p-3">Status</th>
                  <th className="p-3">Approval</th>
                </tr>
              </thead>

              {/* ✅ Scrollable Body */}
              <tbody>
                {activities.map((item, index) => (
                  <tr key={index} className="border-t border-gray-300 hover:bg-gray-50 whitespace-nowrap">

                    <td className="p-3 flex items-center gap-3 min-w-[250px]">
                      <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center shrink-0">
                        <img src={item.imgSrc} alt={item.title} className="w-9 h-9" />
                      </div>
                      <h2 className="text-gray-900 font-semibold">{item.title}</h2>
                    </td>

                    <td className="p-3 min-w-[200px]">{item.assigned}</td>

                    {/* <td className="p-3 min-w-[120px]">
                      <div className="flex gap-2">
                        <button className="p-2 border border-gray-300 rounded-md">
                          <CiShare1 size={21} />
                        </button>
                        <button className="p-2 border border-gray-300 rounded-md">
                          <BsCopy size={20} />
                        </button>
                      </div>
                    </td> */}

                    <td className="p-3 ">
                      {item.type === "Response" &&
                        <div
                          className={`w-44 inline-flex items-center justify-center px-4 py-2 rounded  text-sm font-medium
                        ${item?.status === "Completed"
                              ? " border border-green-500 text-green-500"
                              : " border border-yellow-500  text-yellow-500"
                            }`}
                        >
                          {item?.status}
                        </div>
                      }
                      {item.type === "Meeting" &&
                        <div
                          className={"w-44  bg-gray-100 text-gray-500 inline-flex items-center justify-center px-4 py-2 rounded  text-sm font-medium"}
                        >
                          Meeting
                        </div>
                      }


                    </td>

                    <td className="p-3 w-[170px]">
                      <div className="relative inline-block w-full">
                        <select
                          value={getStatusLabel(objApprove, item)}
                          onChange={(e) => handleApprovalChange(item.sno, e.target.value)}
                          className={'outline-none appearance-none w-full px-4 py-2 rounded ' +
                            (getStatusLabel(objApprove, item) === "Approved" ? "border border-green-500 text-green-500" : "border border-gray-500 text-gray-500") +
                            '  text-sm font-medium cursor-pointer'}
                        >
                          <option value="Pending" className="text-gray-500">Pending</option>
                          <option value="Feedback" className="text-gray-500">Feedback</option>
                          <option value="Approved" className="text-gray-500">Approved</option>
                        </select>

                        <div className={"absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none  " + (getStatusLabel(objApprove, item) === "Approved" ? "text-green-500" : "text-gray-500")}>
                          <MdOutlineArrowDropDown size={24} />
                        </div>
                      </div>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};